/**
 * Removes falsy values from array
 * @param arr
 */
export const filterFalsy = <T>(arr: T[]) => arr.filter(Boolean);

export const getArrayItemByIndex = <T>(index: number, arr: T[]): T =>
  arr[index % arr.length];
